const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const token = window.localStorage.getItem("token");

export const inventoryApi = {
  addInventoryApi: async (info) => {
    try {
      const response = await fetch(`${apiBaseUrl}/inventoryManagement`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${token}`,
        },
        body: JSON.stringify(info),
        credentials: "include",
      });
      if (!response.ok) {
        let responseJson = await response.json();
        throw new Error(responseJson.error);
      }

      const data = await response.json();
      if (data.message) {
        // notification.success({message:data.message})
        return {
          data: data.inventory,
          message: data.message,
        };
      }
    } catch (error) {
      // console.error('Error creating inventory:', error.message);
      throw new Error(error.message);
    }
  },
  getInventoryApi: async () => {
    try {
      const response = await fetch(`${apiBaseUrl}/inventoryManagement`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch inventory");
      }
      const data = await response.json();
      if (data && data.allInv.length > 0) {
        let inventories = [];
        data.allInv.forEach((ele) => {
          inventories.push({
            _id: ele?._id,
            locations: {
              city: ele?.locations?.city,
              Area: ele?.locations?.Area,
              name: ele?.locations?.name,
              zone: ele?.locations?.zone,
            },
            Availability: ele.Availability,
            Illu: ele?.Illu,
            width: ele?.width,
            height: ele?.height,
            CodeNo: ele?.CodeNo,
            CASCode: ele?.CASCode,
            typeOfMedia: ele?.typeOfMedia,
            img: ele?.img,
            vendor: ele?.vendor,
            ownedBy: ele?.ownedBy,
            ratePerMonth: ele?.ratePerMonth,
            Bookings: ele?.Bookings,
            lat: ele?.lat,
            lng: ele?.lng,
            startDate: ele?.startDate,
            endDate: ele?.endDate,
            blocked: ele?.blocked,
            blockedFor: ele?.blockedFor,
            blockedAt: ele?.blockedAt,
            blockedTill: ele?.blockedTill,
            unit: ele?.unit,
            focBookings: ele?.focBookings,
            rotationalBookings: ele?.rotationalBookings,
            half1Id: ele?.half1Id,
            half2Id: ele?.half2Id,
            fullId: ele?.fullId,
            blockedDates: ele?.blockedDates,
            premiumBlock: ele?.premiumBlock,
            maintenanceRate: ele?.maintenanceRate,
            isOverlapPossible: ele?.isOverlapPossible,
          });
        });
        return inventories;
      }
    } catch (error) {
      throw new Error(error.message);
    }
  },
};
